<script>
    export default {
        name: 'AskPriceMessageNotify',
        data() {
            return {
                latestMessageTime: '',
                // interVal: null,
                // latestSendTime: 0,
            };
        },
        computed: {
            // 判断登录Ajax是否完成
            loginAjaxComplete() {
                return this.$store.state.Login.loginAjaxComplete;
            },
            // 登录状态
            loginType() {
                return this.$store.state.Login.loginData.loginType;
            },
        },
        watch: {
            loginAjaxComplete() {
                this.init();
            }
        },
        created() {
            this.init();
        },
        mounted() {
        },
        beforeDestroy() {
            // if (this.interVal) {
            //     clearInterval(this.interVal);
            // }
        },
        methods: {
            init() {
                if (this.loginAjaxComplete && this.loginType) {
                    this.askPriceNotify();
                }
            },
            askPriceNotify() {
                const h = this.$createElement;

                // this.interVal = this.$setInterval(() => {
                // let nowTime = new Date().getTime();
                // if (Number(this.latestSendTime) > 0 && nowTime - Number(this.latestSendTime) < (1000 * 40)) {
                //     return;
                // }

                // this.latestSendTime = nowTime;

                this.$ajax({
                    url: '/AskPriceHandler/AskPriceHandler.ashx',
                    data: {
                        act: 'getAskPriceMessageData',// 获取询价消息的数据
                    },
                    errHandler: false,
                    success: async (res) => {
                        let messageList = res.success.messageList;
                        if (messageList.length > 0) {
                            let tempMessageList = [];
                            if (this.latestMessageTime !== '') {
                                tempMessageList = messageList.filter(message => Number(message.messageTime) > Number(this.latestMessageTime));
                            } else {
                                tempMessageList = messageList;
                            }
                            if (tempMessageList.length > 0) {
                                this.latestMessageTime = tempMessageList[tempMessageList.length - 1].messageTime;
                            }


                            for (let i = tempMessageList.length - 1; i >= 0; i--) {

                                // 1秒间隔
                                await new Promise((resolve) => {
                                    this.$setTimeout(() => {

                                        let _this = this.$notify({
                                            duration: 6000,
                                            customClass: 'askPriceGlobalNotifyCSS',
                                            message: h('div', {
                                                style: 'font-size: 12px;color: #4D4D4D;',
                                            }, [
                                                h('div', '您的询价：'),
                                                h('div', {
                                                    style: 'display: flex;align-items: center;margin-top: 8px;'
                                                }, [
                                                    h('span', {style: 'white-space: nowrap'}, tempMessageList[i].message),
                                                    h('span', {
                                                        style: 'text-decoration: underline;font-weight: 700;margin-left: 10px;white-space: nowrap;cursor: pointer;',
                                                        on: {
                                                            click: () => this.onAskPriceNotifyClick(_this, tempMessageList[i].askId, tempMessageList[i].messageId)
                                                        }
                                                    }, '查看')
                                                ])
                                            ]),
                                            onClose: () => {
                                                this.$ajax({
                                                    url: '/AskPriceHandler/AskPriceHandler.ashx',
                                                    data: {
                                                        act: 'postAskPriceMessageIKnowData',// 提交询价消息我知道了的数据
                                                        messageId: tempMessageList[i].messageId,// 消息id
                                                    },
                                                    errHandler: false
                                                });
                                            }
                                        });
                                        resolve();
                                    }, 500);
                                });


                            }

                        }

                    }
                });

                // }, 1000 * 60);
            },
            onAskPriceNotifyClick(_this, askId) {
                let path = this.$router.resolve({
                    path: '/product/askPrice',
                    query: {askId: askId}
                });

                _this.close();

                window.open(path.href, '_blank');
            }
        }
    };
</script>

<template>
    <div></div>
</template>

<style lang="scss">

    .askPriceGlobalNotifyCSS {
        width: auto !important;
    }
</style>